import { FormRow } from "..";
import { useAppContext } from "../../context/appContext";
import Wrapper from "../../assets/wrappers/AddItemLocation";
import { useTranslation } from "react-i18next";

const AddItemType = () => {
  const {
    isLoading,
    isAddingType,
    isEditingType,
    displayAlert,
    typeName,
    handleChange,
    createItemType,
    editItemType,
    editItemTypeId,
    deleteItemType,
  } = useAppContext();
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!typeName) {
      displayAlert();
      return;
    }
    if (isEditingType) {
      editItemType();
      return;
    }
    createItemType();
  };

  const handleItemInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({ name, value });
  };

  return (
    <Wrapper>
      <form className={isAddingType ? "form_active" : "form"}>
        <div className="form-center">
          <FormRow
            type="text"
            name="typeName"
            value={typeName}
            handleChange={handleItemInput}
            labelText={t("Type Name")}
          />
          <div className="btn-container">
            <button
              type="submit"
              className="btn btn-block submit-btn"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {t("Submit")}
            </button>
            {isEditingType && (
              <button
                type="button"
                className="btn delete-btn"
                onClick={() => deleteItemType(editItemTypeId)}
              >
                {t("Delete")}
              </button>
            )}
          </div>
        </div>
      </form>
    </Wrapper>
  );
};

export default AddItemType;
